import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { executeRecaptcha } from '../util/recaptcha-util';

import {
  HiddenInviteCode,
  HiddenProduct,
  HiddenRedirect,
  HiddenReferral,
  HiddenXSRF
} from './forms';

import IString from './i-string';
import WaitButton from './wait-button';

/**
 * Creates a form for a user to submit their log in to a 3rd party provider.
 *
 * @param {string}  [className]     Class name to apply to the <form>
 * @param {boolean} [register]      True if the user is registering for a new `lucid-auth` account, false otherwise
 * @param {string}   thirdPartyName Name of the 3rd party provider
 */
function ThirdPartyForm({ className, register, thirdPartyName }) {
  const [pending, setPending] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setPending(true);

    const form = e.currentTarget;
    form.elements.recaptcha_token.value = await executeRecaptcha();
    form.submit();
  };

  return (
    <form action={`/login/${thirdPartyName}`} className={className} method='post' onSubmit={handleSubmit}>
      <HiddenInviteCode />
      <HiddenRedirect />
      { register && <HiddenReferral /> }
      <HiddenXSRF />
      <HiddenProduct />
      <input type="hidden" name="recaptcha_token" defaultValue="" />

      <fieldset className='actions noMarginAbove'>
        <WaitButton className={`noSubmitLook withImage ${thirdPartyName}`} type='submit' wait={pending} >
          <IString stringKey={thirdPartyName} />
        </WaitButton>
      </fieldset>
    </form>
  );
}

ThirdPartyForm.propTypes = {
  className: PropTypes.string,
  register: PropTypes.bool,
  thirdPartyName: PropTypes.string.isRequired
};

export default ThirdPartyForm;
